import React, { useState } from "react";
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from "react-native";
import { observer } from "mobx-react";
import { bannerStore } from "../stores/BannerStore";
import { navigate } from "../services/NavigationService";
import { EnumRoutesAppWeb } from "../enum/EnumRoutesAppWeb";
import { PlusIcon, PencilSimpleIcon, TrashIcon, FunnelSimple as FilterIcon } from "@phosphor-icons/react";
import { Theme } from "../enum/Theme";
import SpaceW from "@comps/SpaceW";
import { Language } from "@constants/language";
import { ModalFiltroLanguage } from "../comps/ModalFiltroLanguage";
import { getFlagByLanguage } from "../services/getFlagByLanguage";

const BannerList = observer(() => {
  const { banners, loading, deleteBanner } = bannerStore;

  const [modalVisible, setModalVisible] = useState(false);
  const [filterActive, setFilterActive] = useState<boolean | null>(null);
  const [filterLang, setFilterLang] = useState<Language | null>(null);

  const bannersFiltered = banners.filter((banner) => {
    const activeMatch = filterActive === null || banner.isActive === filterActive;
    const langMatch = filterLang === null || banner.lang === filterLang;
    return activeMatch && langMatch;
  });

  if (loading) {
    return <Text style={{ textAlign: "center", marginTop: 50 }}>Carregando...</Text>;
  }

  return (
    <View style={styles.container}>
      <View style={styles.topBar}>
        <TouchableOpacity style={styles.addButton} onPress={() => navigate(EnumRoutesAppWeb.createEditBanner)}>
          <PlusIcon size={20} color="#fff" />
          <Text style={styles.addButtonText}>Novo Banner</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.filterButton} onPress={() => setModalVisible(true)}>
          <FilterIcon size={22} color={Theme.foreground} />
        </TouchableOpacity>
        {filterLang && (
          <View style={styles.filterTag}>
            <Text style={styles.filterTagText}>{getFlagByLanguage(filterLang)}</Text>
          </View>
        )}
      </View>

      <ScrollView>
        {bannersFiltered.map((banner) => (
          <View style={styles.row} key={banner.id}>
            <View>
              <Text style={{ fontSize: 18 }}>{getFlagByLanguage(banner.lang)}</Text>
            </View>
            <SpaceW />
            <View style={styles.bannerInfo}>
              <Text style={styles.bannerTitle}>{banner.title}</Text>
              <Text style={styles.bannerSubtitle}>
                {banner.targetScreens.join(', ')} • {banner.position} • {banner.isActive ? 'Ativo' : 'Inativo'}
              </Text>
            </View>
            <SpaceW />
            <View style={styles.actions}>
              <TouchableOpacity onPress={() => navigate(EnumRoutesAppWeb.createEditBanner, { banner })}>
                <PencilSimpleIcon size={20} color="#555" />
              </TouchableOpacity>
              <SpaceW />
              <TouchableOpacity onPress={() => deleteBanner(banner.id)}>
                <TrashIcon size={20} color="#E57373" />
              </TouchableOpacity>
            </View>
          </View>
        ))}
      </ScrollView>

      {/* Modal de Filtro */}
      <ModalFiltroLanguage
        visible={modalVisible}
        value={filterLang}
        onSelect={setFilterLang}
        onClose={() => setModalVisible(false)}
      />
    </View>
  );
});

export default BannerList;

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20, backgroundColor: "#F2F2F2" },
  topBar: { flexDirection: "row", alignItems: "center", marginBottom: 15 },
  addButton: { backgroundColor: Theme.foreground, padding: 10, borderRadius: 5, flexDirection: "row", alignItems: "center" },
  addButtonText: { color: "#fff", marginLeft: 5 },
  filterButton: { marginLeft: 10, padding: 7, borderRadius: 5, backgroundColor: "#e6e6e6" },
  filterTag: { marginLeft: 10, padding: 5, borderRadius: 5, backgroundColor: Theme.foreground },
  filterTagText: { color: "#fff", fontSize: 18 },
  row: { flexDirection: "row", justifyContent: "space-between", alignItems: "center", paddingVertical: 10, borderBottomWidth: 1, borderBottomColor: "#ccc" },
  bannerInfo: { flex: 2 },
  bannerTitle: { fontSize: 16, fontWeight: "bold", marginBottom: 4 },
  bannerSubtitle: { fontSize: 12, color: "#666" },
  actions: { flexDirection: "row", gap: 10 },
});
